import type { PreviewAsOption } from "./PreviewAsPicker.types";

export const defaultMatches = (option: PreviewAsOption, query: string): boolean => {
  const needle = query.trim().toLowerCase();
  if (needle === "") return true;
  return `${option.label} ${option.meta ?? ""}`.toLowerCase().includes(needle);
};

/** Up to two initials from a label. */
export const toInitials = (label: string): string =>
  label
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]!.toUpperCase())
    .join("");

/** The option `step` away from `index`, wrapping; `index` -1 starts at the first or last. */
export const stepIndex = (index: number, step: 1 | -1, total: number): number => {
  if (total === 0) return -1;
  if (index === -1) return step === 1 ? 0 : total - 1;
  return (index + step + total) % total;
};
